import React from 'react'

export default class Tab extends React.Component {
  render () {
    return (
      <div className='tab-body'>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Tabs/Tab.js